// extracted by mini-css-extract-plugin
export default {"loading":"zD_Hq6xsoh36e6ucUJ0M"};